/**
 * Transactions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface GetTransaction200Response { 
    id: string;
    websiteId: string;
    websiteUrl: string;
    requestId?: string;
    legitscriptId?: string;
    source: GetTransaction200Response.SourceEnum;
    transactionStatus: GetTransaction200Response.TransactionStatusEnum;
    transactionDate?: string;
    transactionAmount?: number;
    transactionCurrency?: GetTransaction200Response.TransactionCurrencyEnum;
    transactionUSDAmount?: number;
    transactionDescription?: string;
    transactionId?: string;
    ccLast4?: string;
    analysisDate?: string;
    analysisNote: string;
    internalNote?: string;
    cardAcceptorId?: string;
    terminalId?: string;
    posConditionCode?: number;
    posEntryMode?: number;
    rightsHolder?: string;
    rightsHolderContactName?: string;
    rightsHolderContactPhone?: string;
    rightsHolderContactEmail?: string;
    rightsHolderContactAddress?: string;
    recordTags?: Array<any>;
    externalId?: string;
    client: string;
    clientSub?: string;
    accountId: string;
    purchaseAmount?: number;
    mccCategory?: string;
    cardholderLocation?: GetTransaction200Response.CardholderLocationEnum;
    issuerLocation?: GetTransaction200Response.IssuerLocationEnum;
    screenshots?: Array<any>;
    attachments?: Array<any>;
    createdAt: string;
    updatedAt: string;
    createdBy: string;
    updatedBy: string;
    deletedAt?: string;
}
export namespace GetTransaction200Response {
    export type SourceEnum = 'Request' | 'Proactive' | 'Reactive';
    export const SourceEnum = {
        Request: 'Request' as SourceEnum,
        Proactive: 'Proactive' as SourceEnum,
        Reactive: 'Reactive' as SourceEnum
    };
    export type TransactionStatusEnum = 'Pending' | 'Tested' | 'Tested - Hit' | 'Tested - No Hit' | 'Not Tested - Dysfunctional' | 'Not Tested - KYC Requirements' | 'Not Tested - Not Reportable' | 'Not Tested - Parked/Offline' | 'Not Tested - Redirect' | 'Not Tested - Review Only' | 'Not Tested - Non-Client CCs only' | 'Not Tested - No CCs' | 'Not Tested - Other' | 'Not Tested - SMS Verification' | 'Not Tested - Target Jurisdiction Blocked' | 'Ordered';
    export const TransactionStatusEnum = {
        Pending: 'Pending' as TransactionStatusEnum,
        Tested: 'Tested' as TransactionStatusEnum,
        Tested___Hit: 'Tested - Hit' as TransactionStatusEnum,
        Tested___No_Hit: 'Tested - No Hit' as TransactionStatusEnum,
        Not_Tested___Dysfunctional: 'Not Tested - Dysfunctional' as TransactionStatusEnum,
        Not_Tested___KYC_Requirements: 'Not Tested - KYC Requirements' as TransactionStatusEnum,
        Not_Tested___Not_Reportable: 'Not Tested - Not Reportable' as TransactionStatusEnum,
        Not_Tested___Parked_Offline: 'Not Tested - Parked/Offline' as TransactionStatusEnum,
        Not_Tested___Redirect: 'Not Tested - Redirect' as TransactionStatusEnum,
        Not_Tested___Review_Only: 'Not Tested - Review Only' as TransactionStatusEnum,
        Not_Tested___Non_Client_CCs_only: 'Not Tested - Non-Client CCs only' as TransactionStatusEnum,
        Not_Tested___No_CCs: 'Not Tested - No CCs' as TransactionStatusEnum,
        Not_Tested___Other: 'Not Tested - Other' as TransactionStatusEnum,
        Not_Tested___SMS_Verification: 'Not Tested - SMS Verification' as TransactionStatusEnum,
        Not_Tested___Target_Jurisdiction_Blocked: 'Not Tested - Target Jurisdiction Blocked' as TransactionStatusEnum,
        Ordered: 'Ordered' as TransactionStatusEnum
    };
    export type TransactionCurrencyEnum = 'AFN' | 'ALL' | 'DZD' | 'USD' | 'EUR' | 'AOA' | 'XCD' | 'ARS' | 'AMD' | 'AWG' | 'AUD' | 'AZN' | 'BSD' | 'BHD' | 'BDT' | 'BBD' | 'BYN' | 'BZD' | 'XOF' | 'BMD' | 'BTN' | 'INR' | 'BOB' | 'BOV' | 'BAM' | 'BWP' | 'NOK' | 'BRL' | 'BND' | 'BGN' | 'BIF' | 'CVE' | 'KHR' | 'XAF' | 'CAD' | 'KYD' | 'CLF' | 'CLP' | 'CNY' | 'COP' | 'COU' | 'KMF' | 'CDF' | 'NZD' | 'CRC' | 'CUC' | 'CUP' | 'ANG' | 'CZK' | 'DKK' | 'DJF' | 'DOP' | 'EGP' | 'SVC' | 'ERN' | 'ETB' | 'FKP' | 'FJD' | 'XPF' | 'GMD' | 'GEL' | 'GHS' | 'GIP' | 'GTQ' | 'GBP' | 'GNF' | 'GYD' | 'HTG' | 'HNL' | 'HKD' | 'HUF' | 'ISK' | 'IDR' | 'XDR' | 'IRR' | 'IQD' | 'ILS' | 'JMD' | 'JPY' | 'JOD' | 'KZT' | 'KES' | 'KPW' | 'KRW' | 'KWD' | 'KGS' | 'LAK' | 'LBP' | 'LSL' | 'ZAR' | 'LRD' | 'LYD' | 'CHF' | 'MOP' | 'MGA' | 'MWK' | 'MYR' | 'MVR' | 'MRU' | 'MUR' | 'XUA' | 'MXN' | 'MXV' | 'MDL' | 'MNT' | 'MAD' | 'MZN' | 'MMK' | 'NAD' | 'NPR' | 'NIO' | 'NGN' | 'OMR' | 'PKR' | 'PAB' | 'PGK' | 'PYG' | 'PEN' | 'PHP' | 'PLN' | 'QAR' | 'MKD' | 'RON' | 'RUB' | 'RWF' | 'SHP' | 'WST' | 'STN' | 'SAR' | 'RSD' | 'SCR' | 'SLE' | 'SGD' | 'XSU' | 'SBD' | 'SOS' | 'SSP' | 'LKR' | 'SDG' | 'SRD' | 'SZL' | 'SEK' | 'CHE' | 'CHW' | 'SYP' | 'TWD' | 'TJS' | 'TZS' | 'THB' | 'TOP' | 'TTD' | 'TND' | 'TRY' | 'TMT' | 'UGX' | 'UAH' | 'AED' | 'USN' | 'UYI' | 'UYU' | 'UZS' | 'VUV' | 'VEF' | 'VED' | 'VND' | 'YER' | 'ZMW' | 'ZWL' | 'ERU';
    export const TransactionCurrencyEnum = {
        AFN: 'AFN' as TransactionCurrencyEnum,
        ALL: 'ALL' as TransactionCurrencyEnum,
        DZD: 'DZD' as TransactionCurrencyEnum,
        USD: 'USD' as TransactionCurrencyEnum,
        EUR: 'EUR' as TransactionCurrencyEnum,
        AOA: 'AOA' as TransactionCurrencyEnum,
        XCD: 'XCD' as TransactionCurrencyEnum,
        ARS: 'ARS' as TransactionCurrencyEnum,
        AMD: 'AMD' as TransactionCurrencyEnum,
        AWG: 'AWG' as TransactionCurrencyEnum,
        AUD: 'AUD' as TransactionCurrencyEnum,
        AZN: 'AZN' as TransactionCurrencyEnum,
        BSD: 'BSD' as TransactionCurrencyEnum,
        BHD: 'BHD' as TransactionCurrencyEnum,
        BDT: 'BDT' as TransactionCurrencyEnum,
        BBD: 'BBD' as TransactionCurrencyEnum,
        BYN: 'BYN' as TransactionCurrencyEnum,
        BZD: 'BZD' as TransactionCurrencyEnum,
        XOF: 'XOF' as TransactionCurrencyEnum,
        BMD: 'BMD' as TransactionCurrencyEnum,
        BTN: 'BTN' as TransactionCurrencyEnum,
        INR: 'INR' as TransactionCurrencyEnum,
        BOB: 'BOB' as TransactionCurrencyEnum,
        BOV: 'BOV' as TransactionCurrencyEnum,
        BAM: 'BAM' as TransactionCurrencyEnum,
        BWP: 'BWP' as TransactionCurrencyEnum,
        NOK: 'NOK' as TransactionCurrencyEnum,
        BRL: 'BRL' as TransactionCurrencyEnum,
        BND: 'BND' as TransactionCurrencyEnum,
        BGN: 'BGN' as TransactionCurrencyEnum,
        BIF: 'BIF' as TransactionCurrencyEnum,
        CVE: 'CVE' as TransactionCurrencyEnum,
        KHR: 'KHR' as TransactionCurrencyEnum,
        XAF: 'XAF' as TransactionCurrencyEnum,
        CAD: 'CAD' as TransactionCurrencyEnum,
        KYD: 'KYD' as TransactionCurrencyEnum,
        CLF: 'CLF' as TransactionCurrencyEnum,
        CLP: 'CLP' as TransactionCurrencyEnum,
        CNY: 'CNY' as TransactionCurrencyEnum,
        COP: 'COP' as TransactionCurrencyEnum,
        COU: 'COU' as TransactionCurrencyEnum,
        KMF: 'KMF' as TransactionCurrencyEnum,
        CDF: 'CDF' as TransactionCurrencyEnum,
        NZD: 'NZD' as TransactionCurrencyEnum,
        CRC: 'CRC' as TransactionCurrencyEnum,
        CUC: 'CUC' as TransactionCurrencyEnum,
        CUP: 'CUP' as TransactionCurrencyEnum,
        ANG: 'ANG' as TransactionCurrencyEnum,
        CZK: 'CZK' as TransactionCurrencyEnum,
        DKK: 'DKK' as TransactionCurrencyEnum,
        DJF: 'DJF' as TransactionCurrencyEnum,
        DOP: 'DOP' as TransactionCurrencyEnum,
        EGP: 'EGP' as TransactionCurrencyEnum,
        SVC: 'SVC' as TransactionCurrencyEnum,
        ERN: 'ERN' as TransactionCurrencyEnum,
        ETB: 'ETB' as TransactionCurrencyEnum,
        FKP: 'FKP' as TransactionCurrencyEnum,
        FJD: 'FJD' as TransactionCurrencyEnum,
        XPF: 'XPF' as TransactionCurrencyEnum,
        GMD: 'GMD' as TransactionCurrencyEnum,
        GEL: 'GEL' as TransactionCurrencyEnum,
        GHS: 'GHS' as TransactionCurrencyEnum,
        GIP: 'GIP' as TransactionCurrencyEnum,
        GTQ: 'GTQ' as TransactionCurrencyEnum,
        GBP: 'GBP' as TransactionCurrencyEnum,
        GNF: 'GNF' as TransactionCurrencyEnum,
        GYD: 'GYD' as TransactionCurrencyEnum,
        HTG: 'HTG' as TransactionCurrencyEnum,
        HNL: 'HNL' as TransactionCurrencyEnum,
        HKD: 'HKD' as TransactionCurrencyEnum,
        HUF: 'HUF' as TransactionCurrencyEnum,
        ISK: 'ISK' as TransactionCurrencyEnum,
        IDR: 'IDR' as TransactionCurrencyEnum,
        XDR: 'XDR' as TransactionCurrencyEnum,
        IRR: 'IRR' as TransactionCurrencyEnum,
        IQD: 'IQD' as TransactionCurrencyEnum,
        ILS: 'ILS' as TransactionCurrencyEnum,
        JMD: 'JMD' as TransactionCurrencyEnum,
        JPY: 'JPY' as TransactionCurrencyEnum,
        JOD: 'JOD' as TransactionCurrencyEnum,
        KZT: 'KZT' as TransactionCurrencyEnum,
        KES: 'KES' as TransactionCurrencyEnum,
        KPW: 'KPW' as TransactionCurrencyEnum,
        KRW: 'KRW' as TransactionCurrencyEnum,
        KWD: 'KWD' as TransactionCurrencyEnum,
        KGS: 'KGS' as TransactionCurrencyEnum,
        LAK: 'LAK' as TransactionCurrencyEnum,
        LBP: 'LBP' as TransactionCurrencyEnum,
        LSL: 'LSL' as TransactionCurrencyEnum,
        ZAR: 'ZAR' as TransactionCurrencyEnum,
        LRD: 'LRD' as TransactionCurrencyEnum,
        LYD: 'LYD' as TransactionCurrencyEnum,
        CHF: 'CHF' as TransactionCurrencyEnum,
        MOP: 'MOP' as TransactionCurrencyEnum,
        MGA: 'MGA' as TransactionCurrencyEnum,
        MWK: 'MWK' as TransactionCurrencyEnum,
        MYR: 'MYR' as TransactionCurrencyEnum,
        MVR: 'MVR' as TransactionCurrencyEnum,
        MRU: 'MRU' as TransactionCurrencyEnum,
        MUR: 'MUR' as TransactionCurrencyEnum,
        XUA: 'XUA' as TransactionCurrencyEnum,
        MXN: 'MXN' as TransactionCurrencyEnum,
        MXV: 'MXV' as TransactionCurrencyEnum,
        MDL: 'MDL' as TransactionCurrencyEnum,
        MNT: 'MNT' as TransactionCurrencyEnum,
        MAD: 'MAD' as TransactionCurrencyEnum,
        MZN: 'MZN' as TransactionCurrencyEnum,
        MMK: 'MMK' as TransactionCurrencyEnum,
        NAD: 'NAD' as TransactionCurrencyEnum,
        NPR: 'NPR' as TransactionCurrencyEnum,
        NIO: 'NIO' as TransactionCurrencyEnum,
        NGN: 'NGN' as TransactionCurrencyEnum,
        OMR: 'OMR' as TransactionCurrencyEnum,
        PKR: 'PKR' as TransactionCurrencyEnum,
        PAB: 'PAB' as TransactionCurrencyEnum,
        PGK: 'PGK' as TransactionCurrencyEnum,
        PYG: 'PYG' as TransactionCurrencyEnum,
        PEN: 'PEN' as TransactionCurrencyEnum,
        PHP: 'PHP' as TransactionCurrencyEnum,
        PLN: 'PLN' as TransactionCurrencyEnum,
        QAR: 'QAR' as TransactionCurrencyEnum,
        MKD: 'MKD' as TransactionCurrencyEnum,
        RON: 'RON' as TransactionCurrencyEnum,
        RUB: 'RUB' as TransactionCurrencyEnum,
        RWF: 'RWF' as TransactionCurrencyEnum,
        SHP: 'SHP' as TransactionCurrencyEnum,
        WST: 'WST' as TransactionCurrencyEnum,
        STN: 'STN' as TransactionCurrencyEnum,
        SAR: 'SAR' as TransactionCurrencyEnum,
        RSD: 'RSD' as TransactionCurrencyEnum,
        SCR: 'SCR' as TransactionCurrencyEnum,
        SLE: 'SLE' as TransactionCurrencyEnum,
        SGD: 'SGD' as TransactionCurrencyEnum,
        XSU: 'XSU' as TransactionCurrencyEnum,
        SBD: 'SBD' as TransactionCurrencyEnum,
        SOS: 'SOS' as TransactionCurrencyEnum,
        SSP: 'SSP' as TransactionCurrencyEnum,
        LKR: 'LKR' as TransactionCurrencyEnum,
        SDG: 'SDG' as TransactionCurrencyEnum,
        SRD: 'SRD' as TransactionCurrencyEnum,
        SZL: 'SZL' as TransactionCurrencyEnum,
        SEK: 'SEK' as TransactionCurrencyEnum,
        CHE: 'CHE' as TransactionCurrencyEnum,
        CHW: 'CHW' as TransactionCurrencyEnum,
        SYP: 'SYP' as TransactionCurrencyEnum,
        TWD: 'TWD' as TransactionCurrencyEnum,
        TJS: 'TJS' as TransactionCurrencyEnum,
        TZS: 'TZS' as TransactionCurrencyEnum,
        THB: 'THB' as TransactionCurrencyEnum,
        TOP: 'TOP' as TransactionCurrencyEnum,
        TTD: 'TTD' as TransactionCurrencyEnum,
        TND: 'TND' as TransactionCurrencyEnum,
        TRY: 'TRY' as TransactionCurrencyEnum,
        TMT: 'TMT' as TransactionCurrencyEnum,
        UGX: 'UGX' as TransactionCurrencyEnum,
        UAH: 'UAH' as TransactionCurrencyEnum,
        AED: 'AED' as TransactionCurrencyEnum,
        USN: 'USN' as TransactionCurrencyEnum,
        UYI: 'UYI' as TransactionCurrencyEnum,
        UYU: 'UYU' as TransactionCurrencyEnum,
        UZS: 'UZS' as TransactionCurrencyEnum,
        VUV: 'VUV' as TransactionCurrencyEnum,
        VEF: 'VEF' as TransactionCurrencyEnum,
        VED: 'VED' as TransactionCurrencyEnum,
        VND: 'VND' as TransactionCurrencyEnum,
        YER: 'YER' as TransactionCurrencyEnum,
        ZMW: 'ZMW' as TransactionCurrencyEnum,
        ZWL: 'ZWL' as TransactionCurrencyEnum,
        ERU: 'ERU' as TransactionCurrencyEnum
    };
    export type CardholderLocationEnum = 'AFGHANISTAN' | 'ALBANIA' | 'ALGERIA' | 'ANDORRA' | 'ANGOLA' | 'ANTIGUAAND BARBUD' | 'ARGENTINA' | 'ARMENIA' | 'AUSTRALIA' | 'AUSTRIA' | 'AZERBAIJAN' | 'THE BAHAMAS' | 'BAHRAIN' | 'BANGLADESH' | 'BARBADOS' | 'BELARUS' | 'BELGIUM' | 'BELIZE' | 'BENIN' | 'BHUTAN' | 'BOLIVIA' | 'BOSNIA AND HERZEGOVINA' | 'BOTSWANA' | 'BRAZIL' | 'BRUNEI' | 'BULGARIA' | 'BURKINA FASO' | 'BURUNDI' | 'CABO VERDE' | 'CAMBODIA' | 'CAMEROON' | 'CANADA' | 'CENTRAL AFRICAN REPUBLIC' | 'CHAD' | 'CHILE' | 'CHINA' | 'COLOMBIA' | 'COMOROS' | 'DEMOCRATIC' | 'REPUBLIC OF THE CONGO' | 'COSTA RICA' | '\'CÔTE`D\'IVOIRE\'' | 'CROATIA' | 'CUBA' | 'CYPRUS' | 'CZECH REPUBLIC' | 'DENMARK' | 'DJIBOUTI' | 'DOMINICA' | 'DOMINICAN REPUBLIC' | 'EAST TIMOR (TIMOR-LESTE)' | 'ECUADOR' | 'EGYPT' | 'EL SALVADOR' | 'EQUATORIAL GUINEA' | 'ERITREA' | 'ESTONIA' | 'ESWATINI' | 'ETHIOPIA' | 'FIJI' | 'FINLAND' | 'FRANCE' | 'GABON' | 'THE GAMBIA' | 'GEORGIA' | 'GERMANY' | 'GHANA' | 'GREECE' | 'GRENADA' | 'GUATEMALA' | 'GUINEA' | 'GUINEA BISSAU' | 'GUYANA' | 'HAITI' | 'HONDURAS' | 'HONG KONG; CHINA' | 'HUNGARY' | 'ICELAND' | 'INDIA' | 'INDONESIA' | 'IRAN' | 'IRAQ' | 'IRELAND' | 'ISRAEL' | 'ITALY' | 'JAMAICA' | 'JAPAN' | 'JORDAN' | 'KAZAKHSTAN' | 'KENYA' | 'KIRIBATI' | 'NORTH KOREA' | 'SOUTH KOREA' | 'KOSOVO' | 'KUWAIT' | 'KYRGYZSTAN' | 'LAOS' | 'LATVIA' | 'LEBANON' | 'LESOTHO' | 'LIBERIA' | 'LIBYA' | 'LIECHTENSTEIN' | 'LITHUANIA' | 'LUXEMBOURG' | 'MADAGASCAR' | 'MALAWI' | 'MALAYSIA' | 'MALDIVES' | 'MALI' | 'MALTA' | 'MARSHALL ISLANDS' | 'MAURITANIA' | 'MAURITIUS' | 'MEXICO' | 'FEDERATED STATES OF MICRONESIA' | 'MOLDOVA' | 'MONACO' | 'MONGOLIA' | 'MONTENEGRO' | 'MOROCCO' | 'MOZAMBIQUE' | 'MYANMAR (BURMA)' | 'NAMIBIA' | 'NAURU' | 'NEPAL' | 'NETHERLANDS' | 'NEW ZEALAND' | 'NICARAGUA' | 'NIGER' | 'NIGERIA' | 'NORTH MACEDONIA' | 'NORWAY' | 'OMAN' | 'PAKISTAN' | 'PALAU' | 'PANAMA' | 'PAPUA NEW GUINEA' | 'PARAGUAY' | 'PERU' | 'PHILIPPINES' | 'POLAND' | 'PORTUGAL' | 'QATAR' | 'ROMANIA' | 'RUSSIA' | 'RUSSIAN FEDERATION' | 'RWANDA' | 'SAINT KITTS AND NEVIS' | 'SAINT LUCIA' | 'SAINT VINCENT AND THE GRENADINES' | 'SAMOA' | 'SAN MARINO' | 'SAO TOME AND PRINCIPE' | 'SAUDI ARABIA' | 'SENEGAL' | 'SERBIA' | 'SEYCHELLES' | 'SIERRA LEONE' | 'SINGAPORE' | 'SLOVAKIA' | 'SLOVENIA' | 'SOLOMON ISLANDS' | 'SOMALIA' | 'SOUTH AFRICA' | 'SPAIN' | 'SRI LANKA' | 'SUDAN' | 'SUDAN SOUTH' | 'SURINAME' | 'SWEDEN' | 'SWITZERLAND' | 'SYRIA' | 'TAIWAN' | 'TAJIKISTAN' | 'TANZANIA' | 'THAILAND' | 'TOGO' | 'TONGA' | 'TRINIDAD AND TOBAGO' | 'TUNISIA' | 'TURKEY' | 'TURKMENISTAN' | 'TUVALU' | 'UGANDA' | 'UKRAINE' | 'UNITED ARAB EMIRATES' | 'UNITED KINGDOM' | 'UNITED STATES' | 'UNITED STATES OF AMERICA' | 'URUGUAY' | 'UZBEKISTAN' | 'VANUATU' | 'VATICAN CITY' | 'VENEZUELA' | 'VIETNAM' | 'YEMEN' | 'ZAMBIA' | 'ZIMBABWE';
    export const CardholderLocationEnum = {
        AFGHANISTAN: 'AFGHANISTAN' as CardholderLocationEnum,
        ALBANIA: 'ALBANIA' as CardholderLocationEnum,
        ALGERIA: 'ALGERIA' as CardholderLocationEnum,
        ANDORRA: 'ANDORRA' as CardholderLocationEnum,
        ANGOLA: 'ANGOLA' as CardholderLocationEnum,
        ANTIGUAAND_BARBUD: 'ANTIGUAAND BARBUD' as CardholderLocationEnum,
        ARGENTINA: 'ARGENTINA' as CardholderLocationEnum,
        ARMENIA: 'ARMENIA' as CardholderLocationEnum,
        AUSTRALIA: 'AUSTRALIA' as CardholderLocationEnum,
        AUSTRIA: 'AUSTRIA' as CardholderLocationEnum,
        AZERBAIJAN: 'AZERBAIJAN' as CardholderLocationEnum,
        THE_BAHAMAS: 'THE BAHAMAS' as CardholderLocationEnum,
        BAHRAIN: 'BAHRAIN' as CardholderLocationEnum,
        BANGLADESH: 'BANGLADESH' as CardholderLocationEnum,
        BARBADOS: 'BARBADOS' as CardholderLocationEnum,
        BELARUS: 'BELARUS' as CardholderLocationEnum,
        BELGIUM: 'BELGIUM' as CardholderLocationEnum,
        BELIZE: 'BELIZE' as CardholderLocationEnum,
        BENIN: 'BENIN' as CardholderLocationEnum,
        BHUTAN: 'BHUTAN' as CardholderLocationEnum,
        BOLIVIA: 'BOLIVIA' as CardholderLocationEnum,
        BOSNIA_AND_HERZEGOVINA: 'BOSNIA AND HERZEGOVINA' as CardholderLocationEnum,
        BOTSWANA: 'BOTSWANA' as CardholderLocationEnum,
        BRAZIL: 'BRAZIL' as CardholderLocationEnum,
        BRUNEI: 'BRUNEI' as CardholderLocationEnum,
        BULGARIA: 'BULGARIA' as CardholderLocationEnum,
        BURKINA_FASO: 'BURKINA FASO' as CardholderLocationEnum,
        BURUNDI: 'BURUNDI' as CardholderLocationEnum,
        CABO_VERDE: 'CABO VERDE' as CardholderLocationEnum,
        CAMBODIA: 'CAMBODIA' as CardholderLocationEnum,
        CAMEROON: 'CAMEROON' as CardholderLocationEnum,
        CANADA: 'CANADA' as CardholderLocationEnum,
        CENTRAL_AFRICAN_REPUBLIC: 'CENTRAL AFRICAN REPUBLIC' as CardholderLocationEnum,
        CHAD: 'CHAD' as CardholderLocationEnum,
        CHILE: 'CHILE' as CardholderLocationEnum,
        CHINA: 'CHINA' as CardholderLocationEnum,
        COLOMBIA: 'COLOMBIA' as CardholderLocationEnum,
        COMOROS: 'COMOROS' as CardholderLocationEnum,
        DEMOCRATIC: 'DEMOCRATIC' as CardholderLocationEnum,
        REPUBLIC_OF_THE_CONGO: 'REPUBLIC OF THE CONGO' as CardholderLocationEnum,
        COSTA_RICA: 'COSTA RICA' as CardholderLocationEnum,
        CTEDIVOIRE: '\'CÔTE`D\'IVOIRE\'' as CardholderLocationEnum,
        CROATIA: 'CROATIA' as CardholderLocationEnum,
        CUBA: 'CUBA' as CardholderLocationEnum,
        CYPRUS: 'CYPRUS' as CardholderLocationEnum,
        CZECH_REPUBLIC: 'CZECH REPUBLIC' as CardholderLocationEnum,
        DENMARK: 'DENMARK' as CardholderLocationEnum,
        DJIBOUTI: 'DJIBOUTI' as CardholderLocationEnum,
        DOMINICA: 'DOMINICA' as CardholderLocationEnum,
        DOMINICAN_REPUBLIC: 'DOMINICAN REPUBLIC' as CardholderLocationEnum,
        EAST_TIMOR__TIMOR_LESTE: 'EAST TIMOR (TIMOR-LESTE)' as CardholderLocationEnum,
        ECUADOR: 'ECUADOR' as CardholderLocationEnum,
        EGYPT: 'EGYPT' as CardholderLocationEnum,
        EL_SALVADOR: 'EL SALVADOR' as CardholderLocationEnum,
        EQUATORIAL_GUINEA: 'EQUATORIAL GUINEA' as CardholderLocationEnum,
        ERITREA: 'ERITREA' as CardholderLocationEnum,
        ESTONIA: 'ESTONIA' as CardholderLocationEnum,
        ESWATINI: 'ESWATINI' as CardholderLocationEnum,
        ETHIOPIA: 'ETHIOPIA' as CardholderLocationEnum,
        FIJI: 'FIJI' as CardholderLocationEnum,
        FINLAND: 'FINLAND' as CardholderLocationEnum,
        FRANCE: 'FRANCE' as CardholderLocationEnum,
        GABON: 'GABON' as CardholderLocationEnum,
        THE_GAMBIA: 'THE GAMBIA' as CardholderLocationEnum,
        GEORGIA: 'GEORGIA' as CardholderLocationEnum,
        GERMANY: 'GERMANY' as CardholderLocationEnum,
        GHANA: 'GHANA' as CardholderLocationEnum,
        GREECE: 'GREECE' as CardholderLocationEnum,
        GRENADA: 'GRENADA' as CardholderLocationEnum,
        GUATEMALA: 'GUATEMALA' as CardholderLocationEnum,
        GUINEA: 'GUINEA' as CardholderLocationEnum,
        GUINEA_BISSAU: 'GUINEA BISSAU' as CardholderLocationEnum,
        GUYANA: 'GUYANA' as CardholderLocationEnum,
        HAITI: 'HAITI' as CardholderLocationEnum,
        HONDURAS: 'HONDURAS' as CardholderLocationEnum,
        HONG_KONG_CHINA: 'HONG KONG; CHINA' as CardholderLocationEnum,
        HUNGARY: 'HUNGARY' as CardholderLocationEnum,
        ICELAND: 'ICELAND' as CardholderLocationEnum,
        INDIA: 'INDIA' as CardholderLocationEnum,
        INDONESIA: 'INDONESIA' as CardholderLocationEnum,
        IRAN: 'IRAN' as CardholderLocationEnum,
        IRAQ: 'IRAQ' as CardholderLocationEnum,
        IRELAND: 'IRELAND' as CardholderLocationEnum,
        ISRAEL: 'ISRAEL' as CardholderLocationEnum,
        ITALY: 'ITALY' as CardholderLocationEnum,
        JAMAICA: 'JAMAICA' as CardholderLocationEnum,
        JAPAN: 'JAPAN' as CardholderLocationEnum,
        JORDAN: 'JORDAN' as CardholderLocationEnum,
        KAZAKHSTAN: 'KAZAKHSTAN' as CardholderLocationEnum,
        KENYA: 'KENYA' as CardholderLocationEnum,
        KIRIBATI: 'KIRIBATI' as CardholderLocationEnum,
        NORTH_KOREA: 'NORTH KOREA' as CardholderLocationEnum,
        SOUTH_KOREA: 'SOUTH KOREA' as CardholderLocationEnum,
        KOSOVO: 'KOSOVO' as CardholderLocationEnum,
        KUWAIT: 'KUWAIT' as CardholderLocationEnum,
        KYRGYZSTAN: 'KYRGYZSTAN' as CardholderLocationEnum,
        LAOS: 'LAOS' as CardholderLocationEnum,
        LATVIA: 'LATVIA' as CardholderLocationEnum,
        LEBANON: 'LEBANON' as CardholderLocationEnum,
        LESOTHO: 'LESOTHO' as CardholderLocationEnum,
        LIBERIA: 'LIBERIA' as CardholderLocationEnum,
        LIBYA: 'LIBYA' as CardholderLocationEnum,
        LIECHTENSTEIN: 'LIECHTENSTEIN' as CardholderLocationEnum,
        LITHUANIA: 'LITHUANIA' as CardholderLocationEnum,
        LUXEMBOURG: 'LUXEMBOURG' as CardholderLocationEnum,
        MADAGASCAR: 'MADAGASCAR' as CardholderLocationEnum,
        MALAWI: 'MALAWI' as CardholderLocationEnum,
        MALAYSIA: 'MALAYSIA' as CardholderLocationEnum,
        MALDIVES: 'MALDIVES' as CardholderLocationEnum,
        MALI: 'MALI' as CardholderLocationEnum,
        MALTA: 'MALTA' as CardholderLocationEnum,
        MARSHALL_ISLANDS: 'MARSHALL ISLANDS' as CardholderLocationEnum,
        MAURITANIA: 'MAURITANIA' as CardholderLocationEnum,
        MAURITIUS: 'MAURITIUS' as CardholderLocationEnum,
        MEXICO: 'MEXICO' as CardholderLocationEnum,
        FEDERATED_STATES_OF_MICRONESIA: 'FEDERATED STATES OF MICRONESIA' as CardholderLocationEnum,
        MOLDOVA: 'MOLDOVA' as CardholderLocationEnum,
        MONACO: 'MONACO' as CardholderLocationEnum,
        MONGOLIA: 'MONGOLIA' as CardholderLocationEnum,
        MONTENEGRO: 'MONTENEGRO' as CardholderLocationEnum,
        MOROCCO: 'MOROCCO' as CardholderLocationEnum,
        MOZAMBIQUE: 'MOZAMBIQUE' as CardholderLocationEnum,
        MYANMAR__BURMA: 'MYANMAR (BURMA)' as CardholderLocationEnum,
        NAMIBIA: 'NAMIBIA' as CardholderLocationEnum,
        NAURU: 'NAURU' as CardholderLocationEnum,
        NEPAL: 'NEPAL' as CardholderLocationEnum,
        NETHERLANDS: 'NETHERLANDS' as CardholderLocationEnum,
        NEW_ZEALAND: 'NEW ZEALAND' as CardholderLocationEnum,
        NICARAGUA: 'NICARAGUA' as CardholderLocationEnum,
        NIGER: 'NIGER' as CardholderLocationEnum,
        NIGERIA: 'NIGERIA' as CardholderLocationEnum,
        NORTH_MACEDONIA: 'NORTH MACEDONIA' as CardholderLocationEnum,
        NORWAY: 'NORWAY' as CardholderLocationEnum,
        OMAN: 'OMAN' as CardholderLocationEnum,
        PAKISTAN: 'PAKISTAN' as CardholderLocationEnum,
        PALAU: 'PALAU' as CardholderLocationEnum,
        PANAMA: 'PANAMA' as CardholderLocationEnum,
        PAPUA_NEW_GUINEA: 'PAPUA NEW GUINEA' as CardholderLocationEnum,
        PARAGUAY: 'PARAGUAY' as CardholderLocationEnum,
        PERU: 'PERU' as CardholderLocationEnum,
        PHILIPPINES: 'PHILIPPINES' as CardholderLocationEnum,
        POLAND: 'POLAND' as CardholderLocationEnum,
        PORTUGAL: 'PORTUGAL' as CardholderLocationEnum,
        QATAR: 'QATAR' as CardholderLocationEnum,
        ROMANIA: 'ROMANIA' as CardholderLocationEnum,
        RUSSIA: 'RUSSIA' as CardholderLocationEnum,
        RUSSIAN_FEDERATION: 'RUSSIAN FEDERATION' as CardholderLocationEnum,
        RWANDA: 'RWANDA' as CardholderLocationEnum,
        SAINT_KITTS_AND_NEVIS: 'SAINT KITTS AND NEVIS' as CardholderLocationEnum,
        SAINT_LUCIA: 'SAINT LUCIA' as CardholderLocationEnum,
        SAINT_VINCENT_AND_THE_GRENADINES: 'SAINT VINCENT AND THE GRENADINES' as CardholderLocationEnum,
        SAMOA: 'SAMOA' as CardholderLocationEnum,
        SAN_MARINO: 'SAN MARINO' as CardholderLocationEnum,
        SAO_TOME_AND_PRINCIPE: 'SAO TOME AND PRINCIPE' as CardholderLocationEnum,
        SAUDI_ARABIA: 'SAUDI ARABIA' as CardholderLocationEnum,
        SENEGAL: 'SENEGAL' as CardholderLocationEnum,
        SERBIA: 'SERBIA' as CardholderLocationEnum,
        SEYCHELLES: 'SEYCHELLES' as CardholderLocationEnum,
        SIERRA_LEONE: 'SIERRA LEONE' as CardholderLocationEnum,
        SINGAPORE: 'SINGAPORE' as CardholderLocationEnum,
        SLOVAKIA: 'SLOVAKIA' as CardholderLocationEnum,
        SLOVENIA: 'SLOVENIA' as CardholderLocationEnum,
        SOLOMON_ISLANDS: 'SOLOMON ISLANDS' as CardholderLocationEnum,
        SOMALIA: 'SOMALIA' as CardholderLocationEnum,
        SOUTH_AFRICA: 'SOUTH AFRICA' as CardholderLocationEnum,
        SPAIN: 'SPAIN' as CardholderLocationEnum,
        SRI_LANKA: 'SRI LANKA' as CardholderLocationEnum,
        SUDAN: 'SUDAN' as CardholderLocationEnum,
        SUDAN_SOUTH: 'SUDAN SOUTH' as CardholderLocationEnum,
        SURINAME: 'SURINAME' as CardholderLocationEnum,
        SWEDEN: 'SWEDEN' as CardholderLocationEnum,
        SWITZERLAND: 'SWITZERLAND' as CardholderLocationEnum,
        SYRIA: 'SYRIA' as CardholderLocationEnum,
        TAIWAN: 'TAIWAN' as CardholderLocationEnum,
        TAJIKISTAN: 'TAJIKISTAN' as CardholderLocationEnum,
        TANZANIA: 'TANZANIA' as CardholderLocationEnum,
        THAILAND: 'THAILAND' as CardholderLocationEnum,
        TOGO: 'TOGO' as CardholderLocationEnum,
        TONGA: 'TONGA' as CardholderLocationEnum,
        TRINIDAD_AND_TOBAGO: 'TRINIDAD AND TOBAGO' as CardholderLocationEnum,
        TUNISIA: 'TUNISIA' as CardholderLocationEnum,
        TURKEY: 'TURKEY' as CardholderLocationEnum,
        TURKMENISTAN: 'TURKMENISTAN' as CardholderLocationEnum,
        TUVALU: 'TUVALU' as CardholderLocationEnum,
        UGANDA: 'UGANDA' as CardholderLocationEnum,
        UKRAINE: 'UKRAINE' as CardholderLocationEnum,
        UNITED_ARAB_EMIRATES: 'UNITED ARAB EMIRATES' as CardholderLocationEnum,
        UNITED_KINGDOM: 'UNITED KINGDOM' as CardholderLocationEnum,
        UNITED_STATES: 'UNITED STATES' as CardholderLocationEnum,
        UNITED_STATES_OF_AMERICA: 'UNITED STATES OF AMERICA' as CardholderLocationEnum,
        URUGUAY: 'URUGUAY' as CardholderLocationEnum,
        UZBEKISTAN: 'UZBEKISTAN' as CardholderLocationEnum,
        VANUATU: 'VANUATU' as CardholderLocationEnum,
        VATICAN_CITY: 'VATICAN CITY' as CardholderLocationEnum,
        VENEZUELA: 'VENEZUELA' as CardholderLocationEnum,
        VIETNAM: 'VIETNAM' as CardholderLocationEnum,
        YEMEN: 'YEMEN' as CardholderLocationEnum,
        ZAMBIA: 'ZAMBIA' as CardholderLocationEnum,
        ZIMBABWE: 'ZIMBABWE' as CardholderLocationEnum
    };
    export type IssuerLocationEnum = 'AFGHANISTAN' | 'ALBANIA' | 'ALGERIA' | 'ANDORRA' | 'ANGOLA' | 'ANTIGUAAND BARBUD' | 'ARGENTINA' | 'ARMENIA' | 'AUSTRALIA' | 'AUSTRIA' | 'AZERBAIJAN' | 'THE BAHAMAS' | 'BAHRAIN' | 'BANGLADESH' | 'BARBADOS' | 'BELARUS' | 'BELGIUM' | 'BELIZE' | 'BENIN' | 'BHUTAN' | 'BOLIVIA' | 'BOSNIA AND HERZEGOVINA' | 'BOTSWANA' | 'BRAZIL' | 'BRUNEI' | 'BULGARIA' | 'BURKINA FASO' | 'BURUNDI' | 'CABO VERDE' | 'CAMBODIA' | 'CAMEROON' | 'CANADA' | 'CENTRAL AFRICAN REPUBLIC' | 'CHAD' | 'CHILE' | 'CHINA' | 'COLOMBIA' | 'COMOROS' | 'DEMOCRATIC' | 'REPUBLIC OF THE CONGO' | 'COSTA RICA' | '\'CÔTE`D\'IVOIRE\'' | 'CROATIA' | 'CUBA' | 'CYPRUS' | 'CZECH REPUBLIC' | 'DENMARK' | 'DJIBOUTI' | 'DOMINICA' | 'DOMINICAN REPUBLIC' | 'EAST TIMOR (TIMOR-LESTE)' | 'ECUADOR' | 'EGYPT' | 'EL SALVADOR' | 'EQUATORIAL GUINEA' | 'ERITREA' | 'ESTONIA' | 'ESWATINI' | 'ETHIOPIA' | 'FIJI' | 'FINLAND' | 'FRANCE' | 'GABON' | 'THE GAMBIA' | 'GEORGIA' | 'GERMANY' | 'GHANA' | 'GREECE' | 'GRENADA' | 'GUATEMALA' | 'GUINEA' | 'GUINEA BISSAU' | 'GUYANA' | 'HAITI' | 'HONDURAS' | 'HONG KONG; CHINA' | 'HUNGARY' | 'ICELAND' | 'INDIA' | 'INDONESIA' | 'IRAN' | 'IRAQ' | 'IRELAND' | 'ISRAEL' | 'ITALY' | 'JAMAICA' | 'JAPAN' | 'JORDAN' | 'KAZAKHSTAN' | 'KENYA' | 'KIRIBATI' | 'NORTH KOREA' | 'SOUTH KOREA' | 'KOSOVO' | 'KUWAIT' | 'KYRGYZSTAN' | 'LAOS' | 'LATVIA' | 'LEBANON' | 'LESOTHO' | 'LIBERIA' | 'LIBYA' | 'LIECHTENSTEIN' | 'LITHUANIA' | 'LUXEMBOURG' | 'MADAGASCAR' | 'MALAWI' | 'MALAYSIA' | 'MALDIVES' | 'MALI' | 'MALTA' | 'MARSHALL ISLANDS' | 'MAURITANIA' | 'MAURITIUS' | 'MEXICO' | 'FEDERATED STATES OF MICRONESIA' | 'MOLDOVA' | 'MONACO' | 'MONGOLIA' | 'MONTENEGRO' | 'MOROCCO' | 'MOZAMBIQUE' | 'MYANMAR (BURMA)' | 'NAMIBIA' | 'NAURU' | 'NEPAL' | 'NETHERLANDS' | 'NEW ZEALAND' | 'NICARAGUA' | 'NIGER' | 'NIGERIA' | 'NORTH MACEDONIA' | 'NORWAY' | 'OMAN' | 'PAKISTAN' | 'PALAU' | 'PANAMA' | 'PAPUA NEW GUINEA' | 'PARAGUAY' | 'PERU' | 'PHILIPPINES' | 'POLAND' | 'PORTUGAL' | 'QATAR' | 'ROMANIA' | 'RUSSIA' | 'RUSSIAN FEDERATION' | 'RWANDA' | 'SAINT KITTS AND NEVIS' | 'SAINT LUCIA' | 'SAINT VINCENT AND THE GRENADINES' | 'SAMOA' | 'SAN MARINO' | 'SAO TOME AND PRINCIPE' | 'SAUDI ARABIA' | 'SENEGAL' | 'SERBIA' | 'SEYCHELLES' | 'SIERRA LEONE' | 'SINGAPORE' | 'SLOVAKIA' | 'SLOVENIA' | 'SOLOMON ISLANDS' | 'SOMALIA' | 'SOUTH AFRICA' | 'SPAIN' | 'SRI LANKA' | 'SUDAN' | 'SUDAN SOUTH' | 'SURINAME' | 'SWEDEN' | 'SWITZERLAND' | 'SYRIA' | 'TAIWAN' | 'TAJIKISTAN' | 'TANZANIA' | 'THAILAND' | 'TOGO' | 'TONGA' | 'TRINIDAD AND TOBAGO' | 'TUNISIA' | 'TURKEY' | 'TURKMENISTAN' | 'TUVALU' | 'UGANDA' | 'UKRAINE' | 'UNITED ARAB EMIRATES' | 'UNITED KINGDOM' | 'UNITED STATES' | 'UNITED STATES OF AMERICA' | 'URUGUAY' | 'UZBEKISTAN' | 'VANUATU' | 'VATICAN CITY' | 'VENEZUELA' | 'VIETNAM' | 'YEMEN' | 'ZAMBIA' | 'ZIMBABWE';
    export const IssuerLocationEnum = {
        AFGHANISTAN: 'AFGHANISTAN' as IssuerLocationEnum,
        ALBANIA: 'ALBANIA' as IssuerLocationEnum,
        ALGERIA: 'ALGERIA' as IssuerLocationEnum,
        ANDORRA: 'ANDORRA' as IssuerLocationEnum,
        ANGOLA: 'ANGOLA' as IssuerLocationEnum,
        ANTIGUAAND_BARBUD: 'ANTIGUAAND BARBUD' as IssuerLocationEnum,
        ARGENTINA: 'ARGENTINA' as IssuerLocationEnum,
        ARMENIA: 'ARMENIA' as IssuerLocationEnum,
        AUSTRALIA: 'AUSTRALIA' as IssuerLocationEnum,
        AUSTRIA: 'AUSTRIA' as IssuerLocationEnum,
        AZERBAIJAN: 'AZERBAIJAN' as IssuerLocationEnum,
        THE_BAHAMAS: 'THE BAHAMAS' as IssuerLocationEnum,
        BAHRAIN: 'BAHRAIN' as IssuerLocationEnum,
        BANGLADESH: 'BANGLADESH' as IssuerLocationEnum,
        BARBADOS: 'BARBADOS' as IssuerLocationEnum,
        BELARUS: 'BELARUS' as IssuerLocationEnum,
        BELGIUM: 'BELGIUM' as IssuerLocationEnum,
        BELIZE: 'BELIZE' as IssuerLocationEnum,
        BENIN: 'BENIN' as IssuerLocationEnum,
        BHUTAN: 'BHUTAN' as IssuerLocationEnum,
        BOLIVIA: 'BOLIVIA' as IssuerLocationEnum,
        BOSNIA_AND_HERZEGOVINA: 'BOSNIA AND HERZEGOVINA' as IssuerLocationEnum,
        BOTSWANA: 'BOTSWANA' as IssuerLocationEnum,
        BRAZIL: 'BRAZIL' as IssuerLocationEnum,
        BRUNEI: 'BRUNEI' as IssuerLocationEnum,
        BULGARIA: 'BULGARIA' as IssuerLocationEnum,
        BURKINA_FASO: 'BURKINA FASO' as IssuerLocationEnum,
        BURUNDI: 'BURUNDI' as IssuerLocationEnum,
        CABO_VERDE: 'CABO VERDE' as IssuerLocationEnum,
        CAMBODIA: 'CAMBODIA' as IssuerLocationEnum,
        CAMEROON: 'CAMEROON' as IssuerLocationEnum,
        CANADA: 'CANADA' as IssuerLocationEnum,
        CENTRAL_AFRICAN_REPUBLIC: 'CENTRAL AFRICAN REPUBLIC' as IssuerLocationEnum,
        CHAD: 'CHAD' as IssuerLocationEnum,
        CHILE: 'CHILE' as IssuerLocationEnum,
        CHINA: 'CHINA' as IssuerLocationEnum,
        COLOMBIA: 'COLOMBIA' as IssuerLocationEnum,
        COMOROS: 'COMOROS' as IssuerLocationEnum,
        DEMOCRATIC: 'DEMOCRATIC' as IssuerLocationEnum,
        REPUBLIC_OF_THE_CONGO: 'REPUBLIC OF THE CONGO' as IssuerLocationEnum,
        COSTA_RICA: 'COSTA RICA' as IssuerLocationEnum,
        CTEDIVOIRE: '\'CÔTE`D\'IVOIRE\'' as IssuerLocationEnum,
        CROATIA: 'CROATIA' as IssuerLocationEnum,
        CUBA: 'CUBA' as IssuerLocationEnum,
        CYPRUS: 'CYPRUS' as IssuerLocationEnum,
        CZECH_REPUBLIC: 'CZECH REPUBLIC' as IssuerLocationEnum,
        DENMARK: 'DENMARK' as IssuerLocationEnum,
        DJIBOUTI: 'DJIBOUTI' as IssuerLocationEnum,
        DOMINICA: 'DOMINICA' as IssuerLocationEnum,
        DOMINICAN_REPUBLIC: 'DOMINICAN REPUBLIC' as IssuerLocationEnum,
        EAST_TIMOR__TIMOR_LESTE: 'EAST TIMOR (TIMOR-LESTE)' as IssuerLocationEnum,
        ECUADOR: 'ECUADOR' as IssuerLocationEnum,
        EGYPT: 'EGYPT' as IssuerLocationEnum,
        EL_SALVADOR: 'EL SALVADOR' as IssuerLocationEnum,
        EQUATORIAL_GUINEA: 'EQUATORIAL GUINEA' as IssuerLocationEnum,
        ERITREA: 'ERITREA' as IssuerLocationEnum,
        ESTONIA: 'ESTONIA' as IssuerLocationEnum,
        ESWATINI: 'ESWATINI' as IssuerLocationEnum,
        ETHIOPIA: 'ETHIOPIA' as IssuerLocationEnum,
        FIJI: 'FIJI' as IssuerLocationEnum,
        FINLAND: 'FINLAND' as IssuerLocationEnum,
        FRANCE: 'FRANCE' as IssuerLocationEnum,
        GABON: 'GABON' as IssuerLocationEnum,
        THE_GAMBIA: 'THE GAMBIA' as IssuerLocationEnum,
        GEORGIA: 'GEORGIA' as IssuerLocationEnum,
        GERMANY: 'GERMANY' as IssuerLocationEnum,
        GHANA: 'GHANA' as IssuerLocationEnum,
        GREECE: 'GREECE' as IssuerLocationEnum,
        GRENADA: 'GRENADA' as IssuerLocationEnum,
        GUATEMALA: 'GUATEMALA' as IssuerLocationEnum,
        GUINEA: 'GUINEA' as IssuerLocationEnum,
        GUINEA_BISSAU: 'GUINEA BISSAU' as IssuerLocationEnum,
        GUYANA: 'GUYANA' as IssuerLocationEnum,
        HAITI: 'HAITI' as IssuerLocationEnum,
        HONDURAS: 'HONDURAS' as IssuerLocationEnum,
        HONG_KONG_CHINA: 'HONG KONG; CHINA' as IssuerLocationEnum,
        HUNGARY: 'HUNGARY' as IssuerLocationEnum,
        ICELAND: 'ICELAND' as IssuerLocationEnum,
        INDIA: 'INDIA' as IssuerLocationEnum,
        INDONESIA: 'INDONESIA' as IssuerLocationEnum,
        IRAN: 'IRAN' as IssuerLocationEnum,
        IRAQ: 'IRAQ' as IssuerLocationEnum,
        IRELAND: 'IRELAND' as IssuerLocationEnum,
        ISRAEL: 'ISRAEL' as IssuerLocationEnum,
        ITALY: 'ITALY' as IssuerLocationEnum,
        JAMAICA: 'JAMAICA' as IssuerLocationEnum,
        JAPAN: 'JAPAN' as IssuerLocationEnum,
        JORDAN: 'JORDAN' as IssuerLocationEnum,
        KAZAKHSTAN: 'KAZAKHSTAN' as IssuerLocationEnum,
        KENYA: 'KENYA' as IssuerLocationEnum,
        KIRIBATI: 'KIRIBATI' as IssuerLocationEnum,
        NORTH_KOREA: 'NORTH KOREA' as IssuerLocationEnum,
        SOUTH_KOREA: 'SOUTH KOREA' as IssuerLocationEnum,
        KOSOVO: 'KOSOVO' as IssuerLocationEnum,
        KUWAIT: 'KUWAIT' as IssuerLocationEnum,
        KYRGYZSTAN: 'KYRGYZSTAN' as IssuerLocationEnum,
        LAOS: 'LAOS' as IssuerLocationEnum,
        LATVIA: 'LATVIA' as IssuerLocationEnum,
        LEBANON: 'LEBANON' as IssuerLocationEnum,
        LESOTHO: 'LESOTHO' as IssuerLocationEnum,
        LIBERIA: 'LIBERIA' as IssuerLocationEnum,
        LIBYA: 'LIBYA' as IssuerLocationEnum,
        LIECHTENSTEIN: 'LIECHTENSTEIN' as IssuerLocationEnum,
        LITHUANIA: 'LITHUANIA' as IssuerLocationEnum,
        LUXEMBOURG: 'LUXEMBOURG' as IssuerLocationEnum,
        MADAGASCAR: 'MADAGASCAR' as IssuerLocationEnum,
        MALAWI: 'MALAWI' as IssuerLocationEnum,
        MALAYSIA: 'MALAYSIA' as IssuerLocationEnum,
        MALDIVES: 'MALDIVES' as IssuerLocationEnum,
        MALI: 'MALI' as IssuerLocationEnum,
        MALTA: 'MALTA' as IssuerLocationEnum,
        MARSHALL_ISLANDS: 'MARSHALL ISLANDS' as IssuerLocationEnum,
        MAURITANIA: 'MAURITANIA' as IssuerLocationEnum,
        MAURITIUS: 'MAURITIUS' as IssuerLocationEnum,
        MEXICO: 'MEXICO' as IssuerLocationEnum,
        FEDERATED_STATES_OF_MICRONESIA: 'FEDERATED STATES OF MICRONESIA' as IssuerLocationEnum,
        MOLDOVA: 'MOLDOVA' as IssuerLocationEnum,
        MONACO: 'MONACO' as IssuerLocationEnum,
        MONGOLIA: 'MONGOLIA' as IssuerLocationEnum,
        MONTENEGRO: 'MONTENEGRO' as IssuerLocationEnum,
        MOROCCO: 'MOROCCO' as IssuerLocationEnum,
        MOZAMBIQUE: 'MOZAMBIQUE' as IssuerLocationEnum,
        MYANMAR__BURMA: 'MYANMAR (BURMA)' as IssuerLocationEnum,
        NAMIBIA: 'NAMIBIA' as IssuerLocationEnum,
        NAURU: 'NAURU' as IssuerLocationEnum,
        NEPAL: 'NEPAL' as IssuerLocationEnum,
        NETHERLANDS: 'NETHERLANDS' as IssuerLocationEnum,
        NEW_ZEALAND: 'NEW ZEALAND' as IssuerLocationEnum,
        NICARAGUA: 'NICARAGUA' as IssuerLocationEnum,
        NIGER: 'NIGER' as IssuerLocationEnum,
        NIGERIA: 'NIGERIA' as IssuerLocationEnum,
        NORTH_MACEDONIA: 'NORTH MACEDONIA' as IssuerLocationEnum,
        NORWAY: 'NORWAY' as IssuerLocationEnum,
        OMAN: 'OMAN' as IssuerLocationEnum,
        PAKISTAN: 'PAKISTAN' as IssuerLocationEnum,
        PALAU: 'PALAU' as IssuerLocationEnum,
        PANAMA: 'PANAMA' as IssuerLocationEnum,
        PAPUA_NEW_GUINEA: 'PAPUA NEW GUINEA' as IssuerLocationEnum,
        PARAGUAY: 'PARAGUAY' as IssuerLocationEnum,
        PERU: 'PERU' as IssuerLocationEnum,
        PHILIPPINES: 'PHILIPPINES' as IssuerLocationEnum,
        POLAND: 'POLAND' as IssuerLocationEnum,
        PORTUGAL: 'PORTUGAL' as IssuerLocationEnum,
        QATAR: 'QATAR' as IssuerLocationEnum,
        ROMANIA: 'ROMANIA' as IssuerLocationEnum,
        RUSSIA: 'RUSSIA' as IssuerLocationEnum,
        RUSSIAN_FEDERATION: 'RUSSIAN FEDERATION' as IssuerLocationEnum,
        RWANDA: 'RWANDA' as IssuerLocationEnum,
        SAINT_KITTS_AND_NEVIS: 'SAINT KITTS AND NEVIS' as IssuerLocationEnum,
        SAINT_LUCIA: 'SAINT LUCIA' as IssuerLocationEnum,
        SAINT_VINCENT_AND_THE_GRENADINES: 'SAINT VINCENT AND THE GRENADINES' as IssuerLocationEnum,
        SAMOA: 'SAMOA' as IssuerLocationEnum,
        SAN_MARINO: 'SAN MARINO' as IssuerLocationEnum,
        SAO_TOME_AND_PRINCIPE: 'SAO TOME AND PRINCIPE' as IssuerLocationEnum,
        SAUDI_ARABIA: 'SAUDI ARABIA' as IssuerLocationEnum,
        SENEGAL: 'SENEGAL' as IssuerLocationEnum,
        SERBIA: 'SERBIA' as IssuerLocationEnum,
        SEYCHELLES: 'SEYCHELLES' as IssuerLocationEnum,
        SIERRA_LEONE: 'SIERRA LEONE' as IssuerLocationEnum,
        SINGAPORE: 'SINGAPORE' as IssuerLocationEnum,
        SLOVAKIA: 'SLOVAKIA' as IssuerLocationEnum,
        SLOVENIA: 'SLOVENIA' as IssuerLocationEnum,
        SOLOMON_ISLANDS: 'SOLOMON ISLANDS' as IssuerLocationEnum,
        SOMALIA: 'SOMALIA' as IssuerLocationEnum,
        SOUTH_AFRICA: 'SOUTH AFRICA' as IssuerLocationEnum,
        SPAIN: 'SPAIN' as IssuerLocationEnum,
        SRI_LANKA: 'SRI LANKA' as IssuerLocationEnum,
        SUDAN: 'SUDAN' as IssuerLocationEnum,
        SUDAN_SOUTH: 'SUDAN SOUTH' as IssuerLocationEnum,
        SURINAME: 'SURINAME' as IssuerLocationEnum,
        SWEDEN: 'SWEDEN' as IssuerLocationEnum,
        SWITZERLAND: 'SWITZERLAND' as IssuerLocationEnum,
        SYRIA: 'SYRIA' as IssuerLocationEnum,
        TAIWAN: 'TAIWAN' as IssuerLocationEnum,
        TAJIKISTAN: 'TAJIKISTAN' as IssuerLocationEnum,
        TANZANIA: 'TANZANIA' as IssuerLocationEnum,
        THAILAND: 'THAILAND' as IssuerLocationEnum,
        TOGO: 'TOGO' as IssuerLocationEnum,
        TONGA: 'TONGA' as IssuerLocationEnum,
        TRINIDAD_AND_TOBAGO: 'TRINIDAD AND TOBAGO' as IssuerLocationEnum,
        TUNISIA: 'TUNISIA' as IssuerLocationEnum,
        TURKEY: 'TURKEY' as IssuerLocationEnum,
        TURKMENISTAN: 'TURKMENISTAN' as IssuerLocationEnum,
        TUVALU: 'TUVALU' as IssuerLocationEnum,
        UGANDA: 'UGANDA' as IssuerLocationEnum,
        UKRAINE: 'UKRAINE' as IssuerLocationEnum,
        UNITED_ARAB_EMIRATES: 'UNITED ARAB EMIRATES' as IssuerLocationEnum,
        UNITED_KINGDOM: 'UNITED KINGDOM' as IssuerLocationEnum,
        UNITED_STATES: 'UNITED STATES' as IssuerLocationEnum,
        UNITED_STATES_OF_AMERICA: 'UNITED STATES OF AMERICA' as IssuerLocationEnum,
        URUGUAY: 'URUGUAY' as IssuerLocationEnum,
        UZBEKISTAN: 'UZBEKISTAN' as IssuerLocationEnum,
        VANUATU: 'VANUATU' as IssuerLocationEnum,
        VATICAN_CITY: 'VATICAN CITY' as IssuerLocationEnum,
        VENEZUELA: 'VENEZUELA' as IssuerLocationEnum,
        VIETNAM: 'VIETNAM' as IssuerLocationEnum,
        YEMEN: 'YEMEN' as IssuerLocationEnum,
        ZAMBIA: 'ZAMBIA' as IssuerLocationEnum,
        ZIMBABWE: 'ZIMBABWE' as IssuerLocationEnum
    };
}



